import * as React from 'react';

export function PlusIcon() {
  return <svg viewBox="0 0 18 18" id="icon-plus"><polygon points="18 8 10 8 10 0 8 0 8 8 0 8 0 10 8 10 8 18 10 18 10 10 18 10 18 8" /></svg>
}
